module.exports = __webpack_public_path__ + "img/img7.d666d971.svg";